import { render } from "./PreviousRegister.vue?vue&type=template&id=f928c636"
import script from "./PreviousRegister.vue?vue&type=script&lang=js"
export * from "./PreviousRegister.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__